<life-di-nav></life-di-nav>

<div *ngIf="rows && display" class="container text-left overflow-hidden">

  <div class="row d-flex justify-content-center">
    <div class="col-lg-8 col-md-12 col-sm-12">
      <form [formGroup]="searchForm">
        <div class="input-group border mt-3" style="border-radius: 30px; background: #fff; width: 100%;">
          <input class="form-control mr-sm-2" formControlName="input" [(ngModel)]="inputValue" type="search"
            placeholder="ค้นหา" aria-label="Search" nz-input [nzAutocomplete]="auto" (ngModelChange)="onChange($event)"
            style="border: none; border-top-left-radius: 30px; border-bottom-left-radius: 30px;">
          <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>
          <div class="input-group-append">
            <button class="btn" type="submit" [disabled]="!searchForm.valid" (click)="searchClick()">
              <img src="assets/other/search (black).png" alt="" width="15px">
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <hr width="100%">

  <!-- mobile size -->
  <div class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
    <div class="row">
      <div class="col-6 mb-0 mt-2">
        <p class="text-secondary">ผลลัพธ์ {{ display.length }} รายการ</p>
      </div>
      <div class="col-6 mb-3">
        <button class="btn float-right" style="font-size: 15px;" data-toggle="collapse" href="#filter">คัดกรอง
          <img src="assets/filter.png" alt="" style="width: 15px;">
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="collapse mb-3" id="filter">
          <div class="card card-body">
            <div class="row">
              <div class="col mb-3">
                <form [formGroup]="sortForm">
                  <select class="custom-select form-control float-right" formControlName="sort" (change)="sortData()"
                    [(ngModel)]="select">
                    <option value="" selected hidden disabled>เกี่ยวข้องที่สุด</option>
                    <option value="new">ใหม่ที่สุด</option>
                    <option value="price_asc">ราคาต่ำ - สูง</option>
                    <option value="price_desc">ราคาสูง - ต่ำ</option>
                  </select>
                </form>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-6">
                    <h5 class="font-weight-bold text-left">ประเภท</h5>
                  </div>
                  <div class="col-6">
                    <a (click)="clearData('type')">
                      <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">
                        ล้างค่า</p>
                    </a>
                  </div>
                </div>
                <mat-checkbox [(ngModel)]="news" (change)="search()">ข่าว</mat-checkbox><br>
                <mat-checkbox [(ngModel)]="artical" (change)="search()">บทความ</mat-checkbox><br>
                <mat-checkbox [(ngModel)]="course" (change)="search()">คอร์สเรียน</mat-checkbox><br>
                <mat-checkbox [(ngModel)]="workshop" (change)="search()">กิจกรรม</mat-checkbox><br>
                <mat-checkbox [(ngModel)]="measure" (change)="search()">แบบทดสอบ</mat-checkbox><br>
                <mat-checkbox [(ngModel)]="research" (change)="search()">ระบบวิจัย</mat-checkbox>
                <hr width="100%">

                <div *ngIf="course || workshop">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-weight-bold text-left">ราคา</h5>
                    </div>
                    <div class="col-6">
                      <a (click)="clearData('price')">
                        <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">
                          ล้างค่า</p>
                      </a>
                    </div>
                  </div>
                  <mat-checkbox [(ngModel)]="free" (change)="search()">ฟรี</mat-checkbox><br>
                  <mat-checkbox [(ngModel)]="not_free" (change)="search()">มีค่าใช้จ่าย</mat-checkbox><br>
                  <hr width="100%">
                </div>

                <div *ngIf="course">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-weight-bold text-left">รีวิว</h5>
                    </div>
                    <div class="col-6">
                      <a (click)="clearData('review')">
                        <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">
                          ล้างค่า</p>
                      </a>
                    </div>
                  </div>
                  <form [formGroup]="filterForm">
                    <mat-radio-group formControlName="selectRate" [(ngModel)]="review" (change)="search()">
                      <mat-radio-button value="4.5">4.5 ดาวขึ้นไป</mat-radio-button><br>
                      <mat-radio-button value="4">4 ดาวขึ้นไป</mat-radio-button><br>
                      <mat-radio-button value="3.5">3.5 ดาวขึ้นไป</mat-radio-button><br>
                      <mat-radio-button value="3">3 ดาวขึ้นไป</mat-radio-button><br>
                    </mat-radio-group>
                    <hr width="100%">

                    <div class="row">
                      <div class="col-6">
                        <h5 class="font-weight-bold text-left">ระยะเวลาวิดีโอ</h5>
                      </div>
                      <div class="col-6">
                        <a (click)="clearData('video')">
                          <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">
                            ล้างค่า</p>
                        </a>
                      </div>
                    </div>
                    <h5 class="font-weight-bold text-left"></h5>
                    <mat-radio-group formControlName="selectPeriod" [(ngModel)]="course_time" (change)="search()">
                      <mat-radio-button value="0">0-1 ชั่วโมง</mat-radio-button><br>
                      <mat-radio-button value="1">1-3 ชั่วโมง</mat-radio-button><br>
                      <mat-radio-button value="3">3-6 ชั่วโมง</mat-radio-button><br>
                      <mat-radio-button value="6">6-17 ชั่วโมงขึ้นไป</mat-radio-button><br>
                      <mat-radio-button value="17">17 ชั่วโมงขึ้นไป</mat-radio-button><br>
                    </mat-radio-group>
                  </form>
                  <hr width="100%">
                </div>
                <button mat-button style="width: 100%; background: #000; color: #fff;"
                  (click)="reset()">ล้างค่าทั้งหมด</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div *ngIf="rows.length === 0">
          <h5 class="text-center mt-5">
            ขออภัย เราไม่พบผลลัพธ์ใด ๆ สำหรับ "{{ keyword }}"
          </h5>
        </div>
        <div *ngIf="rows.length !== 0">
          <div *ngFor="let d of rows">
            <mat-card class="mb-3 text-left" style="cursor: pointer;"
              (click)="changePage(d.type, d.id, d.link, d.IS_MULTI_INFORMANT)">
              <div class="row">
                <div class="col-4 pr-0">
                  <img [src]="d.pic" alt="" class="img-fluid"
                    style="width: 300px; vertical-align: middle; display: table-cell; min-height: 10em; object-fit: cover;">
                </div>
                <div class="col-8">
                  <div class="row">
                    <div class="col-9">
                      <h6 class="text-left mx-2 lifedi-color font-weight-bold cut-text-title">
                        {{ d.title }}
                      </h6>
                    </div>
                  </div>

                  <div class="text-center"
                    style="background-color: #060E9F; color: #fff; width: 30%; position: absolute; right: -1px; top: 0px; font-size: smaller; height:fit-content;">
                    {{ d.type }}
                  </div>
                  <div *ngIf="d.type === 'ข่าว' || d.type === 'บทความ'">
                    <p class="mx-2 cut-text">
                      {{ d.detail }}
                    </p>
                    <p class="m-0" style="position: absolute; right: 20px; bottom: 0px;">
                      {{ d.date | date }}
                    </p>
                  </div>
                  <div *ngIf="d.type === 'แบบทดสอบ'">
                    <p class="mx-2">
                      ประเภท {{ d.mtype }}
                    </p>
                  </div>
                  <div *ngIf="d.type === 'ระบบวิจัย'">
                    <p class="mx-2">
                      {{ d.wave }} Wave(s) | {{ d.measure }} แบบทดสอบ
                    </p>
                  </div>
                  <div *ngIf="d.type === 'คอร์สเรียน'">
                    <p class="mx-2 text-muted">
                      <ngb-rating class="mt-2" [(rate)]="d.avgPoint" readonly="true" max="5" style="color: #ffc107;">
                      </ngb-rating>
                      {{ d.avgPoint }}/5 ({{ d.countReview }} รีวิว)
                    </p>
                    <p class="mx-2 text-muted">
                      {{ d.countLesson }} บทเรียน | {{ d.countVideo }} วิดีโอ
                      <span *ngIf="d.dulation > 59">
                        (
                        <span *ngIf="d.dulation / 3600 > 1">{{ d.dulation / 3600 | number : '1.0-0' }} ชั่วโมง </span>

                        <span *ngIf="(d.dulation % 3600) / 60 >= 1">{{ (d.dulation % 3600) / 60 | number : '1.0-0' }}
                          นาที</span>
                        )
                      </span>
                    </p>
                    <p class="mx-2">{{ d.username }}</p>
                    <p *ngIf="!d.isPremium" class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <span *ngIf="d.price > 0">{{ d.price | number }} บาท </span>
                      <span *ngIf="d.price === 0">ฟรี </span>
                    </p>
                    <p *ngIf="d.isPremium" class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <img src="assets/crown.png" alt="" class="mb-1" style="width: 20px;">
                      {{ d.premiumPrice | number }} บาท
                    </p>
                  </div>
                  <div *ngIf="d.type === 'กิจกรรม'">
                    <p class="mx-2">
                      {{ d.date[0].dateTime[0] | date }} ( {{ d.date | lengthOfArray }} วัน )
                    </p>
                    <p class="text left mx-2">
                      <img [src]="d.coachPic" class="" style="width: 30px; height: 30px; border-radius: 60%;" alt="">
                      {{ d.username }}
                    </p>
                    <p class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <span *ngIf="d.price > 0">{{ d.price | number }} บาท </span>
                      <span *ngIf="d.price === 0">ฟรี </span>
                    </p>
                  </div>
                  <div *ngIf="d.type === 'ระบบวิจัย'">
                    <p class="m-0 font-weight-bold" style="position: absolute; right: 20px; bottom: 0px;">
                      แชร์ต่อได้รับ {{ d.coinShare }} Coin <img src="/assets/coin.png" class="my-3" style="width: 20px;"
                        alt="">
                    </p>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- mobile size -->

  <!-- desktop size -->
  <div style="padding-bottom: 10px"
    class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">

    <div class="row">
      <div class="col-6 mb-3">
        <h5 class="text-secondary">ผลลัพธ์ {{ display.length }} รายการ</h5>
      </div>
      <div class="col-6 mb-3">
        <form [formGroup]="sortForm">
          <select class="custom-select form-control float-right" style="width: 50%;" formControlName="sort"
            (change)="sortData()" [(ngModel)]="select">
            <option value="" selected hidden disabled>เกี่ยวข้องที่สุด</option>
            <option value="new">ใหม่ที่สุด</option>
            <option value="price_asc">ราคาต่ำ - สูง</option>
            <option value="price_desc">ราคาสูง - ต่ำ</option>
          </select>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-6">
            <h5 class="font-weight-bold text-left">ประเภท</h5>
          </div>
          <div class="col-6">
            <a (click)="clearData('type')">
              <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">ล้างค่า</p>
            </a>
          </div>
        </div>
        <mat-checkbox [(ngModel)]="news" (change)="search()">ข่าว</mat-checkbox><br>
        <mat-checkbox [(ngModel)]="artical" (change)="search()">บทความ</mat-checkbox><br>
        <mat-checkbox [(ngModel)]="course" (change)="search()">คอร์สเรียน</mat-checkbox><br>
        <mat-checkbox [(ngModel)]="workshop" (change)="search()">กิจกรรม</mat-checkbox><br>
        <mat-checkbox [(ngModel)]="measure" (change)="search()">แบบทดสอบ</mat-checkbox><br>
        <mat-checkbox [(ngModel)]="research" (change)="search()">ระบบวิจัย</mat-checkbox>
        <hr width="100%">

        <div *ngIf="course || workshop">
          <div class="row">
            <div class="col-6">
              <h5 class="font-weight-bold text-left">ราคา</h5>
            </div>
            <div class="col-6">
              <a (click)="clearData('price')">
                <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">ล้างค่า</p>
              </a>
            </div>
          </div>
          <mat-checkbox [(ngModel)]="free" (change)="search()">ฟรี</mat-checkbox><br>
          <mat-checkbox [(ngModel)]="not_free" (change)="search()">มีค่าใช้จ่าย</mat-checkbox><br>
          <hr width="100%">
        </div>

        <div *ngIf="course">
          <div class="row">
            <div class="col-6">
              <h5 class="font-weight-bold text-left">รีวิว</h5>
            </div>
            <div class="col-6">
              <a (click)="clearData('review')">
                <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">ล้างค่า</p>
              </a>
            </div>
          </div>
          <form [formGroup]="filterForm">
            <mat-radio-group formControlName="selectRate" [(ngModel)]="review" (change)="search()">
              <mat-radio-button value="4.5">4.5 ดาวขึ้นไป</mat-radio-button><br>
              <mat-radio-button value="4">4 ดาวขึ้นไป</mat-radio-button><br>
              <mat-radio-button value="3.5">3.5 ดาวขึ้นไป</mat-radio-button><br>
              <mat-radio-button value="3">3 ดาวขึ้นไป</mat-radio-button><br>
            </mat-radio-group>
            <hr width="100%">

            <div class="row">
              <div class="col-6">
                <h5 class="font-weight-bold text-left">ระยะเวลาวิดีโอ</h5>
              </div>
              <div class="col-6">
                <a (click)="clearData('video')">
                  <p class="text-right text-secondary" style="font-size: smaller; text-decoration: underline;">ล้างค่า
                  </p>
                </a>
              </div>
            </div>
            <h5 class="font-weight-bold text-left"></h5>
            <mat-radio-group formControlName="selectPeriod" [(ngModel)]="course_time" (change)="search()">
              <mat-radio-button value="0">0-1 ชั่วโมง</mat-radio-button><br>
              <mat-radio-button value="1">1-3 ชั่วโมง</mat-radio-button><br>
              <mat-radio-button value="3">3-6 ชั่วโมง</mat-radio-button><br>
              <mat-radio-button value="6">6-17 ชั่วโมงขึ้นไป</mat-radio-button><br>
              <mat-radio-button value="17">17 ชั่วโมงขึ้นไป</mat-radio-button><br>
            </mat-radio-group>
          </form>
          <hr width="100%">
        </div>
        <button mat-button style="width: 100%; background: #000; color: #fff;" (click)="reset()">ล้างค่าทั้งหมด</button>
      </div>

      <div class="col-9">
        <div *ngIf="rows.length === 0">
          <h4 class="text-center m-5">
            ขออภัย เราไม่พบผลลัพธ์ใด ๆ สำหรับ "{{ keyword }}"
          </h4>
        </div>
        <div *ngIf="rows.length !== 0">
          <div *ngFor="let d of rows">
            <mat-card class="mb-3 text-left" style="cursor: pointer;"
              (click)="changePage(d.type, d.id, d.link, d.IS_MULTI_INFORMANT)">
              <div class="row">
                <div class="col-4">
                  <img [src]="d.pic" alt="" class="img-fluid"
                    style="width: 300px; height: 150px; vertical-align: middle; display: table-cell; min-height: 10em; object-fit: cover;">
                </div>
                <div class="col-8">
                  <div class="row">
                    <div class="col-10">
                      <h4 class="text-left mx-2 lifedi-color cut-text-title">
                        {{ d.title }}
                      </h4>
                    </div>
                  </div>

                  <div class="text-center"
                    style="background-color: #060E9F; color: #fff; width: 15%; position: absolute; right: -1px; top: 0px; font-size: smaller; height:fit-content;">
                    {{ d.type }}
                  </div>
                  <div *ngIf="d.type === 'ข่าว' || d.type === 'บทความ'">
                    <p class="mx-2 cut-text">
                      {{ d.detail }}
                    </p>
                    <p class="m-0" style="position: absolute; right: 20px; bottom: 0px;">
                      {{ d.date | date }}
                    </p>
                  </div>
                  <div *ngIf="d.type === 'แบบทดสอบ'">
                    <p class="mx-2">
                      ประเภท {{ d.mtype }}
                    </p>
                  </div>
                  <div *ngIf="d.type === 'ระบบวิจัย'">
                    <p class="mx-2">
                      {{ d.wave }} Wave(s) | {{ d.measure }} แบบทดสอบ
                    </p>
                  </div>
                  <div *ngIf="d.type === 'คอร์สเรียน'">
                    <p class="mx-2 text-muted">
                      <ngb-rating class="mt-2" [(rate)]="d.avgPoint" readonly="true" max="5" style="color: #ffc107;">
                      </ngb-rating>
                      {{ d.avgPoint }}/5 ({{ d.countReview }} รีวิว)
                    </p>
                    <p class="mx-2 text-muted">
                      {{ d.countLesson }} บทเรียน | {{ d.countVideo }} วิดีโอ
                      <span *ngIf="d.dulation > 59">
                        (
                        <span *ngIf="d.dulation / 3600 > 1">{{ d.dulation / 3600 | number : '1.0-0' }} ชั่วโมง </span>

                        <span *ngIf="(d.dulation % 3600) / 60 >= 1">{{ (d.dulation % 3600) / 60 | number : '1.0-0' }}
                          นาที</span>
                        )
                      </span>
                    </p>
                    <p class="mx-2">{{ d.username }}</p>
                    <p *ngIf="!d.isPremium" class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <span *ngIf="d.price > 0">{{ d.price | number }} บาท </span>
                      <span *ngIf="d.price === 0">ฟรี </span>
                    </p>
                    <p *ngIf="d.isPremium" class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <img src="assets/crown.png" alt="" class="mb-1" style="width: 20px;">
                      <span *ngIf="d.premiumPrice > 0">{{ d.premiumPrice | number }} บาท</span>
                      <span *ngIf="d.premiumPrice === 0">ฟรี</span>
                    </p>
                  </div>
                  <div *ngIf="d.type === 'กิจกรรม'">
                    <p class="mx-2">
                      {{ d.date[0].dateTime[0] | date }} ( {{ d.date | lengthOfArray }} วัน )
                    </p>
                    <p class="text left mx-2 my-2">
                      <img [src]="d.coachPic" class="mr-3" style="width: 30px; height: 30px; border-radius: 60%;"
                        alt="">
                      {{ d.username }}
                    </p>
                    <p class="m-0 font-weight-bold"
                      style="position: absolute; right: 20px; bottom: 0px; color: #DE5C8B;">
                      <span *ngIf="d.price > 0">{{ d.price | number }} บาท </span>
                      <span *ngIf="d.price === 0">ฟรี </span>
                    </p>
                  </div>
                  <div *ngIf="d.type === 'ระบบวิจัย'">
                    <p class="m-0 font-weight-bold" style="position: absolute; right: 20px; bottom: 0px;">
                      แชร์ต่อได้รับ {{ d.coinShare }} Coin <img src="/assets/coin.png" class="m-3" style="width: 30px;"
                        alt="">
                    </p>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- desktop size -->

  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>

<lifedi-footer *ngIf="rows && display"></lifedi-footer>